import * as React from 'react';
import moment from 'moment';
import { GanttChart } from 'components';
import PropTypes from 'prop-types';
import messages from 'messages/Workbench/ProjectDetail';

export interface TimeInfoProps {
  prefixCls: string;
}

class TimeInfo extends React.Component<TimeInfoProps, any> {

  public static contextTypes = {
    intl: PropTypes.object,
    account: PropTypes.object,
    detail: PropTypes.object,
  };

  private getTasks = () => {
    const { intl, detail } = this.context;
    const { expect_begin_at, expect_end_at, actual_begin_at, actual_end_at } = detail;
    const tasks = [];

    tasks.push({
      startDate: moment(expect_begin_at).toDate(),
      endDate: moment(expect_end_at).toDate(),
      taskName: intl.formatMessage(messages.expectDate),
      status: 'DISABLED',
    });

    if (actual_begin_at) {
      tasks.push({
        startDate: moment(actual_begin_at).toDate(),
        endDate: moment(actual_end_at).toDate(),
        taskName: intl.formatMessage(messages.actualDate),
        status: 'RUNNING',
      });
    }

    return tasks;
  }

  public render() {
    const { account = {} } = this.context;
    const { language = 'zh-CN' } = account;
    const { prefixCls } = this.props;
    const className = `${prefixCls}-time-info`;
    const tasks = this.getTasks();
    return (
      <div className={className}>
        <GanttChart
          taskNames={tasks.map((task: any) => task.taskName)}
          tasks={tasks}
          language={language}
        />
      </div>
    );
  }

}

export default TimeInfo;
